import { useCallback, useState } from 'react';

import Button from 'components/field/Button';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';

const AddButton = ({ onRowAdd, setEditing, setExpanded, addIndex }) => {
	const [loading, setLoading] = useState(false);
	const isMobile = useMediaQuery(Breakpoints.mobile);

	const handleButtonClick = useCallback(async () => {
		setLoading(true);

		onRowAdd && (await onRowAdd());
		setEditing((prev) => [...prev, addIndex]);
		if (isMobile) {
			setExpanded((prev) => ({
				...prev,
				[addIndex]: true
			}));
		}

		setLoading(false);
	}, [isMobile, addIndex, onRowAdd, setEditing, setExpanded]);

	return (
		<Button
			variant={isMobile ? 'action' : 'blackOutline'}
			icon={faPlus}
			label="addNewRow"
			className="my-3"
			loading={loading}
			onClick={handleButtonClick}
		/>
	);
};

export default AddButton;
